import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators, AbstractControl } from "@angular/forms";
import { DeleteAccountService } from "./service/delete-account.service";
import { UserDetailsService } from "src/app/services/user/user-details.service";

@Component({
  selector: 'app-delete-account-password',
  templateUrl: './delete-account-password.component.html',
  styleUrls: ['./delete-account-password.component.css']
})
export class DeleteAccountPasswordComponent implements OnInit {
  showReNewPwd: boolean = false;
  showPwd?: boolean = false;

  showError: boolean = false;
  public form: FormGroup;

  constructor(private formBuilder: FormBuilder, private deleteAccountService: DeleteAccountService,
    private userDetailsService: UserDetailsService) {

    this.form = this.formBuilder.group({
      password: ["", Validators.compose([Validators.required])],
      confirmPassword: ["", Validators.compose([Validators.required])],
    });
  }
  ngOnInit(): void { }

  submitPassword() {
    if (this.form.valid && this.form.value.password == this.form.value.confirmPassword) {
      this.showError = false;
      // this.loader = true;
      this.deleteAccountService.deleteAccountConfirmation({ 'password': this.form.value.password });
    } else {
      this.showError = true;
    }
  }
}
